/* eslint-disable react/no-did-update-set-state */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Input from "../Input/Input";

class InputSearchBox extends Component {
  constructor(props) {
    super(props);
    const { selectedItem, items } = this.props;
    this.state = {
      inputText: this.getSelectedLabel(items, selectedItem),
      isSearch: false
    };
    this.wrapperRef = React.createRef(null);
  }

  componentDidMount = () => {
    window.addEventListener("click", this.handleClickOutside, true);
  }

  componentDidUpdate = (prevProps) => {
    const { selectedItem, items } = this.props;
    const { selectedItem: prevSelectedItem, items: prevItems } = prevProps;
    const selectedItemChanged = selectedItem !== prevSelectedItem;
    const itemsBecameAvailable =
      (!prevItems || prevItems.length === 0) && items.length > 0;
    if (
      selectedItemChanged ||
      (itemsBecameAvailable && selectedItem != null && selectedItem !== '')
    ) {
      this.setState({
        isSearch: false,
        inputText: this.getSelectedLabel(items, selectedItem),
      })
    }
  }

  getSelectedLabel = (items, selectedItem) => {
    if (selectedItem == null || selectedItem === '') {
      return '';
    }
    const selected = items.find(
      item => item.value === selectedItem || String(item.value) === String(selectedItem)
    );
    return selected?.label ?? '';
  };

  handleClickOutside = (e) => {
    const { inputText, isSearch } = this.state;
    if (isSearch && this.wrapperRef?.current) {
      const { items, onSelectItem } = this.props;
      const ref = this.wrapperRef?.current
      if(!ref.contains(e?.target)){
        const selected = items.find(item => item.label === inputText);
        this.setState({
          isSearch: false,
          inputText: selected?.label ?? '',
        });
        if (!selected) {
          onSelectItem(null, null);
        }
      }     
    }
  };

  handleSearchItem = inputText => {
    this.setState({
      inputText,
      isSearch: true
    });
  };

  handleItemSearchSelect = item => {
    const { onSelectItem } = this.props;

    onSelectItem(item.value, item.label);

    this.setState({
      isSearch: false,
      inputText: item.label
    });
  };

  render() {
    const { label, items, prompt } = this.props;
    const { inputText, isSearch } = this.state;
    return (
      <div ref={this.wrapperRef}>
        <Input
          label={label}
          type="text"
          handleInput={e => this.handleSearchItem(e?.target?.value)}
          handleOnFocus={e => this.handleSearchItem(e?.target?.value)}
          value={inputText ?? ''}
          name='inputSearchBox'
          autoComplete="off"
        />
        {Array.isArray(items) && items.length > 0 && isSearch && (
          <div
            className="font-montserratMedium text-dark dark:text-white
                w-full border-[1px]
                border-borderLight dark:border-none bg-white dark:bg-darkDry overflow-y-scroll max-h-[212px] mb-12 md:mb-0"
          >
            {items
              .filter(
                item =>
                  item.label.toLowerCase().indexOf(inputText.toLowerCase()) !== -1
                  || (prompt && item.label.toLowerCase().indexOf(prompt.toLowerCase()) !== -1)
              )
              .map(item => (
                <div
                  key={item.value}
                  onClick={() => this.handleItemSearchSelect(item)}
                  onKeyPress={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleItemSearchSelect(item);
                    }
                  }}
                  role="button"
                  aria-label={item.label}
                  tabIndex={0}
                  className="cursor-pointer p-2 hover:bg-light dark:hover:bg-darkDry suggestions"
                >
                  {item.label}
                </div>
              ))}
          </div>
        )}
      </div>
    );
  }
}

InputSearchBox.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  })).isRequired,
  onSelectItem: PropTypes.func.isRequired,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
};

InputSearchBox.defaultProps = {
  selectedItem: "",
  prompt: null,
};

export default InputSearchBox;
